<mat-icon>{{
  !!direction
    ? direction === 'asc'
      ? 'expand_less'
      : 'expand_more'
    : 'unfold_more'
}}</mat-icon>
